export default __webpack_public_path__ + "static/feature-right-img-edb7fbce298f675e104838e3e950ba40.png";